export const EmbedGoogleReviewsDashboardTexts = {
  header: 'Add Google Reviews',
  templateLabel: 'Template',
  carousel: 'Carousel',
  badge: 'Badge',
  colorScheme: 'Color Scheme',
  light: 'Light',
  dark: 'Dark',
  cardCornerRadius: 'Cards Corners Radius',
  accentColorLabel: 'Accent Color',
  backgroundColorLabel: 'Background Color',
  cardBackgroundColorLabel: 'Card Background Color',
  textColorLabel: 'Text Color',
  starsColorLabel: 'Stars Color',
  linkTextColorLabel: 'Link Text Color',
  buttonLabelColorLabel: 'Button Label Color',
  fontLabel: 'Font',
  customCSS: 'Custom CSS Code',
  enterCode: 'Enter Code Here',
  customNote:
    'Important: Custom code is active only upon widget installation and does not function in preview.',
  publish: 'Publish',
  enableExternalLinks: 'Enable External Links',
  openLinksInNewTab: 'Open Links in New Tab',
  showProfilePictures: 'Show Profile Pictures',
  showNames: 'Show Names',
  showCTAButton: 'Show CTA Button',
  buttonText: 'Button Text',
  minRating: 'Minimum Rating',
  totalReviews: 'Total Reviews To Show',
  excludeReviews: 'Exclude Reviews',
  addExcludeRule: 'Add Rule',
  excludeNote: 'Remove some reviews from your widget',
  includeReviews: 'Include Reviews',
  addIncludeRule: 'Add Rule',
  includeNote: 'Control which reviews appear in your widget',
  desktop: 'Desktop',
  mobile: 'Mobile',
  widgetText: 'Widget Name',
  saveChanges: 'Save Changes',
  showOnlyCommentedReviews: 'Show Only Reviews With Comments',
  showOnlyCommentedReviewsTooltip:
    'Enable this to display only reviews that include written feedback. Reviews without comments will be excluded.'
};

export const widgetTexts = {
  title: 'Widget Preview',
  desktop: 'Desktop',
  mobile: 'Mobile',
  reviewNow: 'Rate us now',
  ratingText: 'on Google',
  readMore: 'Read more',
  readLess: 'Read less',
  tooltipText:
    'This is a preview of how your reviews will appear on your site. Up to 10 reviews will show here, based on your latest imports.',
  noReviews: 'No Reviews Found',
  reviews: 'Reviews'
};

export const optionsGrid = [
  'Inter',
  'Roboto',
  'Open Sans',
  'Lato',
  'Poppins',
  'Montserrat',
  'Nunito',
  'Ubuntu',
  'Raleway',
  'Merriweather',
  'Source Sans Pro',
  'PT Sans',
  'Oswald',
  'Titillium Web',
  'Work Sans',
  'Noto Sans',
  'Quicksand',
  'Manrope',
  'Arial',
  'Georgia',
  'Tahoma',
  'Verdana',
  'Trebuchet MS',
  'Times New Roman'
];

export const EmbedYourWidgetModalTexts = {
  title: 'Embed Your Widget',
  subtitle: 'Embed this code on your Squarespace website',
  embedCode: `<script src="https://static.elfsight.com/platform.js" async></script>
<div class="elfsight-app-e31a2015-5440-4c7f-b5a5-59cb0603b1cc" data-elfsight-app-lazy></div>`,
  backButton: 'Back To Google Reviews',
  copyButton: 'Copy Code',
  youtubeLink: 'https://www.youtube.com/embed/1IwejKrqUtc?si=pwvTXJR6ideSU0T6',
  copied: 'Copied!'
};

export const validateCSS = `/* Main summary wrapper */
.review-summary-box {}

/* Stars + rating */
.review-summary-header {}

/* "5.0 Rating" text */
.review-summary-rating {}

/* Span showing number rating */
.review-summary-rating-value {}

/* Star icons container */
.review-summary-stars {}

/* Single star icon */
.review-summary-star-icon {}

/* Review count + button */
.review-summary-footer {}

/* "X Reviews" text */
.review-summary-count {}

/* Number part */
.review-summary-count-value {}

/* Call to action button */
.review-summary-cta-button {}


/* Card container */
.review-card {}

/* Top section of card */
.review-card-top {}

/* Google logo + stars row */
.review-card-stars-row {}

/* Google image */
.review-card-google-icon {}

/* Stars container */
.review-card-stars {}

/* Star inside card */
.review-card-star-icon {}

/* Main review content */
.review-card-text {}

/* Span for read more/less toggle */
.review-card-readmore {}

/* Avatar + reviewer */
.review-card-bottom {}

/* Reviewer avatar */
.review-card-avatar {}

/* Box with name + time */
.review-card-reviewer {}

/* Reviewer name */
.review-card-reviewer-name {}

/* Review timestamp */
.review-card-time {}


/* Dot wrapper */
.review-dots {}

/* Individual dot */
.review-dot {}

/* Active dot */
.review-dot.active {}


/* Badge card */
.review-badge {}

/* Google logo box */
.review-badge-logo {}

/* Google image */
.review-badge-google-icon {}

/* Stars and score */
.review-badge-text-group {}

/* Stars row */
.review-badge-stars-row {}

/* Stars group */
.review-badge-stars {}

/* Star icon */
.review-badge-star-icon {}

/* 5.0 score */
.review-badge-score {}

/* Total reviews text */
.review-badge-total {}

/* "Reviews" span */
.review-badge-total-label {}

/* Outer wrapper switching between badge and carousel */
.review-template-wrapper {}


/* Wrapper around carousel arrows + cards */
.review-carousel-container {}


/* Left arrow icon in carousel */
.review-carousel-arrow-left {}


/* Right arrow icon in carousel */
.review-carousel-arrow-right {}


/* Scrollable horizontal row of review cards */
.review-carousel-scroll-wrapper {}


/* Text shown when no reviews exist in carousel */
.review-no-data-text {}
`;

export const WidgetsDashboardTexts = {
  manageGoogleReviewsWidgets: 'Manage Google Reviews Widgets',
  copyCode: 'Copy Code',
  createNewWidget: 'Create New Widget',
  noWidgetText:
    'All widgets have been removed. Please create a new one to continue.'
};

export const WidgetDeleteModalTexts = {
  delete: 'Delete ',
  desc: 'Are you sure you want to remove this widget?',
  proceed: 'Proceed',
  cancel: 'Cancel',
  note: 'Note: ',
  noteDesc:
    'Adding this script to the header may not ensure proper functionality in some instances.'
};

export const WidgetFieldsTooltipTexts = {
  template: `Choose how your widget looks:\n
• Carousel: shows full reviews in a slider.\n
• Badge: shows your average rating and total reviews.`,
  widgetName: `Give your widget a name so you can find it easily later. This name won't be shown on your site.`,
  colorScheme: `Pick a light or dark theme to match your site’s style.`,
  cardCornerRadius: `Change how round the widget’s corners look — applies to the main widget and all review cards.`,
  accentColor: `Choose the color that highlights key parts of your widget like stars and buttons.`,
  font: `Pick the font used in the widget to match your site’s design.`,
  showCTAButton: `Add a button to your widget that links to your Google review page. You can change the button text to say whatever you like.`,
  minimumRating: 'Only show reviews with this star rating or higher.',
  totalReviewsToShow: `Choose which reviews to show based on how recent they are: all time, last 7 days, last 30 days or last 3 months.`,
  excludeRules: `Hide reviews that match certain words or phrases. You can filter by:\n
• Starts with\n
• Ends with\n
• Contains\n
• Does not contain\n
• Contains exact word`,
  includeRules: `Only show reviews that match the words or phrases you choose, using the same rule types as exclude.`,
  customCSS: `Add your own CSS here if you want to change the style beyond the standard settings.`
};
